export const INTRO_CONSTANTS = {
  title: "Break Free from VMware. Accelerate with OpenStack. ",
  text: "Rising licensing costs. Uncertain roadmap. Limited flexibility. VMware has become a burden for many organizations. With MOST, OneMind’s Managed OpenStack offering, you gain the freedom of open infrastructure, enterprise-grade control, and cloud-native agility—all backed by experts who’ve done this migration countless times. ",
};
